<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
      <v-col cols="12">
        <AddressStructuredField
          @change="v.address.$model = $event"
          :value="v.address.$model"
          :v="v.address"
          label="Место жительства"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

import {
  getValidationErrorText,
  EMAIL,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  PERSON_NAME,
} from '@/utils/validate';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  address: '',
  email: '',
};

export const personValidation = {
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  address: {
    required,
    ...addressValidate(),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
};

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddressStructuredField,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
